export default __webpack_public_path__ + "static/media/a037-10.7a0ddeb4.svg";